jQuery( document ).ready(function() {

  if($('.articlesblog_filter').length > 0) {
    $(".filter-btn").click(function(){
        var term = $(this).data("term");
        $(".filter-btn").removeClass("active");
        $(this).addClass("active");

        $(".articlesblog_item").each(function(){
            $(".filter-input").each(function() {
                if ($(this).val() == term) {
                    $(this).parent().removeClass("hidden");
                } else {
                     $(this).parent().addClass("hidden");
                }
            });
        });
        if ($(this).data("term") == 'all') {
            $(".articlesblog_item").removeClass("hidden");
        }
    });
  }

});